(() => {
  const END = Date.parse('2026-09-11T23:00:00Z');
  const STAMP = '2026-09-11T23:00:00Z';
  const BRUSH = 54452259258709;
  const MASSAGERS = [54916729340245,54926588019029,54926588051797];
  const memoryKey = 'soma-cupping-gift-v19';
  let anchor = Date.now(), tick = performance.now(), ended = false, syncing, cleaning;
  const now = () => anchor + performance.now() - tick;
  const active = () => now() < END;
  const root = () => document.querySelector('[data-soma-cupping][data-offer-end]');
  function rememberLegacy(cart) {
    if (!active()) return;
    const quantity = cart.items.filter(i => MASSAGERS.includes(i.variant_id)).reduce((sum,i)=>sum+i.quantity,0);
    const gifts = cart.items.filter(i => i.variant_id === BRUSH && !i.properties?._soma_free_brush_until && i.final_line_price === 0 && JSON.stringify(i.discounts || i.discount_allocations || []).includes('Free facial brush with Soma Cupping Massager'));
    const legacy = Math.min(quantity, gifts.reduce((sum,i)=>sum+i.quantity,0));
    try { sessionStorage.setItem(memoryKey, String(legacy)); } catch (_) {}
  }
  async function sync() {
    if (syncing) return syncing;
    syncing = (async () => {
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', {cache:'no-store',headers:{Accept:'application/json'}});
      if (!response.ok) throw Error('Unable to check the offer. Please try again.');
      const server = Date.parse(response.headers.get('date'));
      if (Number.isFinite(server)) { anchor = server; tick = performance.now(); }
      const cart = await response.json();
      rememberLegacy(cart);
      render();
      return cart;
    })();
    try { return await syncing; } finally { syncing = null; }
  }
  async function cleanup(cart) {
    if (active()) return false;
    if (cleaning) return cleaning;
    cleaning = (async () => {
      let legacy = 0;
      try { legacy = Number(sessionStorage.getItem(memoryKey)) || 0; } catch (_) {}
      const updates = {};
      for (const item of cart.items) {
        if (item.variant_id !== BRUSH) continue;
        if (item.properties?._soma_free_brush_until === STAMP) updates[item.key] = 0;
        else if (legacy && !item.properties?._soma_free_brush_until) {
          const remove = Math.min(legacy,item.quantity);updates[item.key] = item.quantity-remove;legacy -= remove;
        }
      }
      if (!Object.keys(updates).length) return false;
      const response = await fetch((window.Shopify?.routes?.root || '/')+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates})});
      if (!response.ok) throw Error('Please refresh your cart to remove the expired gift.');
      try { sessionStorage.removeItem(memoryKey); } catch (_) {}
      document.dispatchEvent(new CustomEvent('soma:cart-updated'));
      return true;
    })();
    try { return await cleaning; } finally { cleaning = null; }
  }
  function render() {
    const element = root();
    if (!element) return;
    const available = active();
    element.dataset.offerActive = String(available);
    if (available) {
      const seconds = Math.max(0,Math.floor((END-now())/1000));
      for (const [name,value] of [['hours',Math.floor(seconds/3600)],['minutes',Math.floor(seconds%3600/60)],['seconds',seconds%60]]) {
        element.querySelectorAll('[data-offer-'+name+']').forEach(el=>el.textContent=String(value).padStart(2,'0'));
      }
    } else if (!ended) {
      ended = true;
      const status = element.querySelector('.sc-cart-status');
      if(status && /free brush/i.test(status.textContent))status.textContent='The free-brush offer has ended.';
      const choice = element.querySelector('[data-color-choice]:checked');
      if (choice) {
        element.querySelectorAll('img').forEach(img=>{
          if (img.src.includes('soma-cupping-visual-v5-hero.webp')) { img.src=choice.dataset.image;img.alt=choice.dataset.color+' Soma Cupping Massager'; }
        });
        element.querySelectorAll('button[data-image]').forEach(button=>{
          if(button.dataset.image.includes('soma-cupping-visual-v5-hero.webp'))button.dataset.image=choice.dataset.image;
        });
      }
    }
  }
  window.somaCuppingOffer = {
    active, render,
    async items(variant) {
      const cart = await sync();
      if (!active()) await cleanup(cart);
      const items=[{id:variant,quantity:1}];
      if (active()) items.push({id:BRUSH,quantity:1,properties:{_soma_free_brush_until:STAMP}});
      return items;
    }
  };
  let wasActive=active(), checkingOut=false;
  function start() {
    render();
    sync().then(async cart=>{if(await cleanup(cart))location.reload();}).catch(()=>{});
    setInterval(()=>{
      render();
      if(wasActive && !active())sync().then(async cart=>{if(await cleanup(cart))location.reload();}).catch(()=>{});
      wasActive=active();
    },1000);
  }
  // A cart left open past the deadline must not turn the automatic gift into a paid item.
  document.addEventListener('click',async event=>{
    const button=event.target.closest('[name="checkout"],a[href^="/checkout"],a[href*="/checkouts/"]');
    if(!button || checkingOut || active())return;
    event.preventDefault();event.stopImmediatePropagation();
    try {const cart=await sync();if(await cleanup(cart)){location.reload();return;}checkingOut=true;button.click();}
    catch(error){const status=document.querySelector('.sc-cart-status');if(status)status.textContent=error.message;}
    finally{checkingOut=false;}
  },true);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})();
